import { render, staticRenderFns } from "./BookCollection.vue?vue&type=template&id=ab7c3c20&scoped=true"
import script from "./BookCollection.vue?vue&type=script&lang=js"
export * from "./BookCollection.vue?vue&type=script&lang=js"
import style0 from "./BookCollection.vue?vue&type=style&index=0&id=ab7c3c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7c3c20",
  null
  
)

export default component.exports